import { Http } from '@/model/Http.js'

export default class invite extends Http {
  //邀请好友列表
  getInviteList(data){
    const url = 'api/open/platform/search'
    return this.postAjaxByKfc(url, {
       ...data
    })
  }

}



// WEBPACK FOOTER //
// ./src/javaApi/kfc/invite.js